<template>
  <div>
    <!-- content -->
    <div class="content--block">
      <!-- single news -->
      <div class="article">
        <div class="article--wrapper">
          <div class="article--item" v-if="newsDetails">
            <div class="article--header">
              <h1 class="article--header-heading">{{ newsDetails.title }}</h1>
              <p class="article--header-publish-date">{{ newsDetails.publishedAt | UTCToDate }}</p>
            </div>
            <div class="articles--content">
              <div class="custom-content--paragraph" v-html="newsDetails.publishedContent"/>
            </div>
            <div class="article--buttons">
              <router-link :to="{name:'news'}" class="article--recommended-item-cta">
                <p>All news</p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  class
                >
                  <path d="M6 0L4.94 1.06l4.19 4.19H0v1.5h9.13l-4.19 4.19L6 12l6-6-6-6"></path>
                </svg>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <!--/. single news -->
    </div>
    <!--/. content -->
  </div>
</template>
<script>
import * as api from "../modules/api.js";

export default {
  name: "single-news",
  data: function() {
    return {
      permalink: null,
      newsDetails: null
    };
  },
  mounted() {
    this.permalink = this.$route.path.split("/").pop();
    let me = this;
    api.request(api.newsGetByPermalink, {}, me.permalink).then(function(value) {
      me.newsDetails = value;

      if (value.hasOwnProperty("metaTitle") && value.metaTitle) document.title = value.metaTitle;
      if (value.hasOwnProperty("metaDescription") && value.metaDescription) $("meta[name='description']").attr("content", value.metaDescription);

      me.newsDetails.publishedContent = me.newsDetails.publishedContent.replace(
        "<p>&lt;!--more--&gt;</p>",
        ""
      );
    }).catch(function (value) {
      me.$router.push({ path: "/p/pages/404" });
    });
  }
};
</script>